import { render, staticRenderFns } from "./pageFollowReply.vue?vue&type=template&id=84f00dd4&scoped=true"
import script from "./pageFollowReply.vue?vue&type=script&lang=js"
export * from "./pageFollowReply.vue?vue&type=script&lang=js"
import style0 from "./pageFollowReply.vue?vue&type=style&index=0&id=84f00dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f00dd4",
  null
  
)

export default component.exports